import { FC } from 'react';
import { Button, ButtonStyles, PopupFooterProps } from '@silverfort/sf-components';
import { SendEnrollmentEmailPopupState } from '../types';

type CustomizeEnrollmentEmailFooterProp = PopupFooterProps<SendEnrollmentEmailPopupState> & {
    onAbort: () => void;
    onDone: (state: SendEnrollmentEmailPopupState) => void;
};

const CustomizeEnrollmentEmailFooter: FC<CustomizeEnrollmentEmailFooterProp> = ({
    popupState,
    onAbort,
    onDone,
    onCancel
}) => {
    if (!popupState) {
        return null;
    }
    const { formValues, isValid } = popupState;

    const disabled = !formValues.tokenTypeId || !isValid;

    const handleCancel = () => {
        if (popupState) {
            onAbort();
            onCancel();
        }
    };
    const handleSave = () => {
        if (popupState) {
            onDone(popupState);
            onCancel();
        }
    };
    return (
        <div className="flex flex-1 justify-end gap-2 ">
            <Button buttonStyle={ButtonStyles.GhostSolid} text="Cancel" onClick={handleCancel} />
            <Button buttonStyle={ButtonStyles.PrimarySolid} text="Send" onClick={handleSave} disabled={disabled} />
        </div>
    );
};

export default CustomizeEnrollmentEmailFooter;
